import React from 'react';
import { Alert, Button } from '@mui/material';

export interface ErrorRetryProps {
  message?: string;
  onRetry: () => void;
  isLoading?: boolean;
}

export const ErrorRetry: React.FC<ErrorRetryProps> = ({
  message = 'Error al cargar.',
  onRetry,
  isLoading = false,
}) => (
  <Alert
    severity="error"
    action={
      <Button color="inherit" size="small" onClick={onRetry} disabled={isLoading}>
        Reintentar
      </Button>
    }
  >
    {message}
  </Alert>
);
